<template>
  <div class="contactForm">
    <h1>{{$t('footer.contactForm.title')}}</h1>
    <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
      <b-form-group id="email">
        <b-form-input
          id="email-input"
          v-model="email"
          type="email"
          required
          :placeholder="$t('footer.contactForm.emailPlaceholder')"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="message">
        <b-form-textarea
          id="textarea"
          v-model="message"
          :placeholder="$t('footer.contactForm.messagePlaceholder')"
          rows="7"
          max-rows="7"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group id="file">
        <b-form-file
          ref="file"
          v-model="file"
          :state="Boolean(file)"
          :placeholder="$t('footer.contactForm.filePlaceholder')"
          :drop-placeholder="$t('footer.contactForm.fileDrop')"
        ></b-form-file>
      </b-form-group>
      <div class="buttons">
        <p class="success" v-show="success">{{$t('footer.contactForm.success')}}</p>
        <vue-recaptcha
          ref="recaptcha"
          :loadRecaptchaScript="true"
          @verify="onVerify"
          size="invisible"
          sitekey="6LceuLMUAAAAAJ4gPVCBI7Oy9kAV54jCrDQiCbIS"
        >
          <b-button type="submit" variant="primary">{{$t('footer.contactForm.submit')}}</b-button>
        </vue-recaptcha>
      </div>
    </b-form>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      message: "",
      file: "",
      success: false
    };
  },
  methods: {
    onSubmit() {
      this.$refs.recaptcha.execute();
      this.success = false;
    },
    onVerify(responseCaptcha) {
      let formData = new FormData();
      formData.append("email", this.email);
      formData.append("message", this.message);
      formData.append("file", this.file);
      formData.append("captcha", responseCaptcha);
      this.email = "";
      this.message = "";
      this.file = "";
      axios
        .post("/mail/send", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data == "ok") {
            this.resetRecaptcha();
            this.success = true;
          }
        });
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
  },
  components: {
    VueRecaptcha
  }
};
</script>

<style scoped>
#textarea {
  overflow: hidden !important;
}

h1 {
  font-family: "Neue Montreal", sans-serif;
  font-weight: 600;
  text-align: center;
}

.contactForm {
  margin: 10px;
  color: #2c3e50;
}

.buttons {
  text-align: center;
  margin: 20px 0 0 0;
}

.btn-primary {
  background: #2c3e50;
}

.success {
  color: lightgreen;
  font-weight: 600;
}
</style>